import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const TemplateAPI = {
  create: function ({ org_id, name, labels, width, height, description }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/templates`,
      data: { name, labels, size: { width, height }, description },
    })
  },
}

const cancelTokenObject = createCancelToken(TemplateAPI)
export default TemplateAPI
